import { render } from "./sales-returns.vue?vue&type=template&id=7fc00cfd"
import script from "./sales-returns.vue?vue&type=script&lang=js"
export * from "./sales-returns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__